import React from 'react'

const RightsholderMaintenanceContactTabHeader = () => (
    <>
        <p> Information entered on the Identifiers tab is used for Member identification. </p>
    </>
)

export default RightsholderMaintenanceContactTabHeader
